import React, { useRef } from 'react';
import { useEmbedChildBridge } from '@home/hooks/useEmbedChildBridge';
import {
  DEFAULT_EMBED_ROUTE,
  GAMEWIKI_APP_ID,
  GAMEWIKI_BASE,
  GAMEWIKI_MOUNT_PATH,
  isGameWikiAllowedEmbedPath,
} from './constants';
import { gameWikiParentToChildPath, gameWikiChildToParentPath } from './utils';
import './index.scss';

/**
 * GameWiki 嵌入页
 *
 * 父 URL 示例：
 * - /v2/gamewiki/space/{spaceId} ↔ 子 /kb/platform/knowledge-bases?tenantId={spaceId}
 * - /v2/gamewiki/space/personal ↔ 子 /kb/platform/knowledge-bases（个人空间，无 tenantId）
 * - /v2/gamewiki/space/{spaceId}/kb/{kbId} ↔ 子 /kb/platform/knowledge-bases/{kbId}?fromTenantId={spaceId}
 * 路由同步：route-change / route-clear / ready / navigate
 * 鉴权：auth-required → 主框架 doLogout（子应用内嵌时不自行跳登录）
 * 外观同步：iframe 首屏 src 带 ?theme=&lang=（防默认暗色闪屏），运行中 postMessage theme/lang
 */

const GameWikiHome: React.FC = () => {
  const iframeRef = useRef<HTMLIFrameElement>(null);

  const { iframeSrc } = useEmbedChildBridge({
    appId: GAMEWIKI_APP_ID,
    parentMountPath: GAMEWIKI_MOUNT_PATH,
    basePath: GAMEWIKI_BASE,
    defaultRoute: DEFAULT_EMBED_ROUTE,
    iframeRef,
    pathValidator: isGameWikiAllowedEmbedPath,
    parentToChildPath: gameWikiParentToChildPath,
    childToParentPath: gameWikiChildToParentPath,
  });

  return (
    <div className="dbh-gamewiki-home">
      <iframe
        ref={iframeRef}
        title="game-wiki"
        className="dbh-gamewiki-home__iframe"
        src={iframeSrc}
      />
    </div>
  );
};

export default GameWikiHome;
